import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import DailySalesReportAPI from './../../../api/DailySalesReportAPI';
import ChartComponent from "../FixedReportChart";

class DailySalesLeadsByPropertyType extends React.Component {
  constructor(props) {
    super(props);

    // Load property_type options from local storage
    const propertytypeOptions = reactLocalStorage.getObject(Constants.Model).property.fields.property_type.options;


    this.state = {
      propertytypeOptions,  // Predefined property_type options
      ProjectSums: {},
    };
  }

  componentDidMount() {
    // Fetch data from the API
    DailySalesReportAPI.getleadsByPropertyType(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const {  propertytypeOptions } = this.state;
     // Create a record of sums for each project option, starting at 0
     const ProjectSums = propertytypeOptions.reduce((acc, option) => {
        acc[option.value] = 0;
        return acc;
     }, {});
 
     // Fill in the actual values from the API data
     data.forEach(item => {
       const project = [item.property_type] || item.property_type.split('~').filter(Boolean);
       project.forEach(pr => {
        ProjectSums[parseInt(pr)] += item.sum;
       })
     });
    this.setState({ ProjectSums});
    
  };


  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { ProjectSums, propertytypeOptions } = this.state;
    // Calculate the total sum of all property_type values
    const totalSum = Object.values(ProjectSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Property Configuration Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-5">
            <thead>
              <tr>
                <th>Configuration</th>
                <th>Total Properties</th>
              </tr>
            </thead>
            <tbody>
              {propertytypeOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{ProjectSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-5">
            {/* Add Chart Component */}
            <ChartComponent progressSums={ProjectSums} progressOptions={propertytypeOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(DailySalesLeadsByPropertyType);
